import { render, staticRenderFns } from "./WallDonationBlockGeneralSettings.vue?vue&type=template&id=8ef220e0"
import script from "./WallDonationBlockGeneralSettings.vue?vue&type=script&lang=js"
export * from "./WallDonationBlockGeneralSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports